/**
 * FRONT-1036: per-composer draft text, persisted to localStorage keyed by
 * draftKey (usually a sessionId; the pre-session launcher composer, which
 * has no sessionId yet, passes a fixed literal instead — see chat-input.tsx's
 * `draftKey` prop). Namespaced per key from the start — FRONT-820/1035's
 * model mode toggle had to move off a single shared browser-wide key
 * precisely because it bled across every open chat; this avoids that failure
 * mode rather than repeating it.
 */

function storageKey(draftKey: string): string {
  return `eddy.chat.draft.${draftKey}`;
}

export function loadDraft(draftKey: string | undefined): string {
  if (!draftKey) return '';
  try {
    return localStorage.getItem(storageKey(draftKey)) ?? '';
  } catch {
    return '';
  }
}

export function persistDraft(draftKey: string | undefined, text: string): void {
  if (!draftKey) return;
  try {
    if (text.trim()) {
      localStorage.setItem(storageKey(draftKey), text);
    } else {
      localStorage.removeItem(storageKey(draftKey));
    }
  } catch {
    /* quota or storage disabled — draft becomes session-only */
  }
}
